import { useState } from 'react';

import NextImage from 'next/image';
import { twMerge } from 'tailwind-merge';

import { ISeoSpeciesFamilyItem } from '@domain/species/types';
import { getSpeciesUrl } from '@domain/routes/urls';
import { Button } from '../../Clickables/Buttons/Button';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { ChevronDownIcon } from '../../Icons/ChevronDownIcon';

interface IProps {
  family: ISeoSpeciesFamilyItem;
  className: string;
}

export const SEOFishFamily = ({ family, className }: IProps) => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const { svg, seoFamilyName } = family;

  return (
    <div className={twMerge('', className)}>
      <div className="flex justify-center">
        <NextImage
          className="w-full sm:w-1/2"
          src={svg.src}
          alt={seoFamilyName}
          width={125}
          height={75}
        />
      </div>

      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {family.seoFamilySpecies.map((specie, index) => (
          <InternalLink
            className={`bg-twilight rounded-lg p-3 ${index > 3 && !showMore ? 'hidden' : 'flex'} `}
            to={getSpeciesUrl(specie.externalId, specie.commonName)}
            key={`SEOFishFamily-${specie.externalId}`}
          >
            {specie.commonName}
            <ArrowRightIcon size={18} className="ml-1" />
          </InternalLink>
        ))}
      </div>

      {!showMore && family.seoFamilySpecies.length > 4 && (
        <div className="flex justify-center pt-4 pb-2">
          <Button
            variant="textPrimary"
            className="flex flex-col items-center"
            onClick={() => {
              setShowMore(true);
            }}
          >
            See all species
            <ChevronDownIcon />
          </Button>
        </div>
      )}
    </div>
  );
};
